import { Message } from '../types/whatsapp.types';

// Couleurs du projet SING
export const C = {
  primary: '#00758d',
  dark: '#00303c',
  gold: '#dfc32f',
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444',
  bg: '#f8fafc',
  cardBg: '#ffffff',
  border: '#e2e8f0',
  text: '#1e293b',
  textMuted: '#64748b',
  textLight: '#94a3b8',
};

// Fake data for demo
export const MOCK_MESSAGES: Message[] = [
  {
    id: '1',
    from: '+241 74 13 71 03',
    fromName: 'Jean Dupont',
    body: 'Bonjour, je souhaite réserver une salle de conférence pour 20 personnes le 15 mars.',
    timestamp: new Date(Date.now() - 300000),
    isGroup: false,
    type: 'text',
    botReplied: true,
  },
  {
    id: '2',
    from: '+241 66 00 12 34',
    fromName: 'Marie Nkoghe',
    body: 'Quels sont vos tarifs pour le coworking ?',
    timestamp: new Date(Date.now() - 180000),
    isGroup: false,
    type: 'text',
    botReplied: true,
  },
  {
    id: '3',
    from: '+241 77 55 66 88',
    fromName: 'Tech Gabon SARL',
    body: "Nous avons besoin d'un bureau permanent pour 3 personnes.",
    timestamp: new Date(Date.now() - 60000),
    isGroup: false,
    type: 'text',
    botReplied: false,
  },
];
